// extracted by mini-css-extract-plugin
export default {"alternativesTable":"cseTvrW_1","takenContainer":"cs7uxxZQV","takenTLD":"cxDSN0KgQ","yellowBlock":"ckaJqhvce","continueButtonContainer":"cW70USDUS"};